import { ChangeDetectorRef, Component, Renderer2 } from '@angular/core';
import { Observable, take } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ContentService } from '../../spartacus/services/content.service';
import { CmsComponentData } from '@spartacus/storefront';
import { BaseSiteService, CmsBannerComponent, OccConfig } from '@spartacus/core';

@Component({
  selector: 'app-custom-dashboard-slides',
  standalone: false,
  templateUrl: './custom-dashboard-slides.component.html',
  styleUrls: ['./custom-dashboard-slides.component.scss']
})
export class CustomDashboardSlidesComponent {
  constructor(
    public component: CmsComponentData<CmsBannerComponent>, 
    protected config: OccConfig, 
    public accessService: ContentService, 
    public cd: ChangeDetectorRef, 
    private userInfoService: UserInfoService,
    private baseSiteService: BaseSiteService,
    private renderer: Renderer2) {
  }
  dashboardSlideNode: Observable<any> = this.component.data$;
  mergedObject1: any ;
  userInfo : any;
  rbavalue: any;
  currentSite: string | undefined;
  userLoggedIn: boolean = false;

  ngOnInit() {
    this.dashboardSlideNode.subscribe(res => {
      this.slideresources(res);
    });
     this.rbavalue = localStorage.getItem('rbapermission');
    this.rbavalue = JSON.parse(this.rbavalue);
    this.cd.detectChanges();

    this.userInfoService.getswitchrba().subscribe(value => {
      if (value) {
        this.rbavalue = value;
        this.cd.detectChanges();
      }
    });
  }
   ngAfterViewInit() {
    this.userInfoService.getrbaheader().subscribe(value => {
      if (value) {
        // this.rbavarible=localStorage.getItem('rbapermission');
        this.rbavalue = value;
        this.cd.detectChanges();
      }
    });

  }
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.url;
  }

  slideresources(res: any) {
    const tilesList = res?.dashboardSlides?.split(" ");
    if(tilesList){
     this.accessService.opeffeaturedResources(tilesList).subscribe((res : any) => {
      this.mergedObject1 = res.component;
      this.cd.detectChanges();
     });
    }
  }
}
